import { IconBookmark, IconInfo, IconPencil, IconPlug, IconShare, IconSignal, IconTools, IconUpload } from '@assets/images/icon';
import { IconTopology } from '@assets/images/main';
import { vehicleTrackingKit5, yardTrackingKit4 } from '@assets/images/main/outdoor';

export default {
  a: [
    { text: '기술 방식', icon: IconInfo },
    { text: '위치 정확도', icon: IconSignal },
    { text: '전송 주기', icon: IconUpload },
    { text: '연동 구조', icon: IconTopology },
    { text: '전원 입력', icon: IconPlug },
    { text: '추천 환경', icon: IconBookmark },
    { text: '특장점', icon: IconPencil },
    { text: '외부 연동', icon: IconShare },
  ],

  b: [
    { text: 'GNSS 기반 GPS 위치 측정' },
    { text: '±3 meters' },
    { text: '1분당 30회(최대)' },
    { text: 'GPS Device(LTE) → ORBRO Server' },
    { text: 'USB-C' },
    { text: '차량 위치추적, 자산 위치추적' },
    { text: '단말 하나로 위치정보 획득 가능' },
    { text: 'API 제공' },
  ],

  c: [
    { text: 'LoRA 기반 GPS 신호 수신' },
    { text: '±3 meters' },
    { text: '1분당 120회(최대)' },
    { text: 'GPS Tag → LoRA 수신기 → ORBRO Server' },
    { text: 'PoE' },
    { text: '야드, 항만, 물류센터, 공사현장 등' },
    { text: '특정지역에서 다수 태그 신호를 수신,<br/>통신비용 없이 사용 가능' },
    { text: 'API 제공 (실시간 이벤트/위치/상황 연동)' },
  ],

  spec: [
    {},

    {
      image: vehicleTrackingKit5,
      link: '/outdoor/gps',
      title: 'GPS Device',
      desc: '',
    },

    {
      image: yardTrackingKit4,
      link: '/outdoor/lora',
      title: 'GPS Tag(LoRA)',
      desc: '',
    },
  ],
};
